module.exports = __webpack_public_path__ + "img/logo-simple.af75d231.png";